export default {
  data()
  {
    return {
      lang: this.getCurrentLanguage()
    }
  },
  methods: {
    getCurrentLanguage()
    {
      let lang = 'en' // default language
      if (this.$i18n && this.$i18n.locale)
      {
        switch (this.$i18n.locale)
        {
          case 'gb' :
            lang = 'en'
            break
          case 'ee' :
            lang = 'et'
            break
        }
      }
      return lang
    }
  }
}
